<div class="main-page">
  <app-header></app-header>
  <div class="container">
    <!-- <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader> -->

    <div class="advertisement">
      <div class="innerPage advertisement-inner">
        <div class="advertisement-text">
          <span class="nav-divnk">Ministry Messages</span>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xs-12 col-sm-12">
          <div class="drop-dash" style="min-height: 500px">
            <div class="display margin-b">
              <div
                class="tabButton mRight header-style cursor"
                id="create"
                [ngClass]="{ active: activeTab === 'create' }"
                (click)="getScrollTo('create')"
              >
                Postcards
              </div>
              <div
                class="tabButton mLeft header-style cursor"
                id="manage"
                [ngClass]="{ active: activeTab === 'manage' }"
                (click)="getScrollTo('manage')"
              >
                Alerts
              </div>
            </div>
            <div
              *ngIf="activeTab === 'create'"
              class="content-div"
              style="background-color: white;"
            >
            <div class="mm-postcards">
              <div class="mm-postcards__header">
                <div>
                  <div class="mm-postcards__title">Postcards</div>
                  <div class="mm-postcards__subtitle">Messages from your affiliated communities</div>
                </div>
                <div class="mm-postcards__meta" *ngIf="postcardsTotal">
                  {{ postcardsTotal }} items
                </div>
              </div>

              <div *ngIf="announcemnts?.length > 0; else noPostcards" class="mm-postcards__grid">
                <div *ngFor="let announcemnt of announcemnts" class="mm-postcard">
                  <div class="mm-postcard__top">
                    <div class="mm-postcard__title-text">{{ announcemnt.name }}</div>
                    <div class="mm-postcard__date">
                      {{ announcemnt.createdAt | date: 'MMM dd, yyyy • hh:mm a' }}
                    </div>
                  </div>
                  <div class="mm-postcard__desc">{{ announcemnt.description }}</div>
                  <div class="mm-postcard__footer" *ngIf="announcemnt?.createdBy?.name">
                    <span class="mm-postcard__by">By {{ announcemnt.createdBy.name }}</span>
                  </div>
                </div>
              </div>

              <div class="mm-pagination" *ngIf="postcardsTotalPages > 1">
                <button
                  type="button"
                  class="mm-page-btn"
                  [disabled]="postcardsPage <= 1"
                  (click)="postcardsPrevPage()"
                >
                  Prev
                </button>
                <div class="mm-page-meta">
                  Page <b>{{ postcardsPage }}</b> of <b>{{ postcardsTotalPages }}</b>
                </div>
                <button
                  type="button"
                  class="mm-page-btn"
                  [disabled]="postcardsPage >= postcardsTotalPages"
                  (click)="postcardsNextPage()"
                >
                  Next
                </button>
              </div>

              <ng-template #noPostcards>
                <div class="mm-empty">
                  <div class="mm-empty__title">No postcards</div>
                  <div class="mm-empty__subtitle">Once communities post updates, you’ll see them here.</div>
                </div>
              </ng-template>
            </div>
            </div>
            <div *ngIf="activeTab === 'manage'" class="content-div" style="background-color: white;">
              <div class="mm-alerts">
                <div class="mm-alerts__header">
                  <div>
                    <div class="mm-alerts__title">Alerts</div>
                    <div class="mm-alerts__subtitle">Create and manage your latest alerts</div>
                  </div>
                  <button type="button" class="mm-btn mm-btn--primary" (click)="toggleCreateAlert()">
                    <i class="fa" [ngClass]="showCreateAlert ? 'fa-times' : 'fa-plus'"></i>
                    {{ showCreateAlert ? 'Close' : 'Add Alert' }}
                  </button>
                </div>

                <div class="mm-alerts__grid">
                  <div class="mm-card mm-card--form" *ngIf="showCreateAlert">
                    <div class="mm-card__head">
                      <div class="mm-card__head-title">Create Alert</div>
                      <button type="button" class="mm-icon-btn" (click)="closeCreateAlert()" aria-label="Close">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>

                    <form [formGroup]="alertForm" (ngSubmit)="createAlert()" class="mm-form">
                      <div class="form-group">
                        <label>Alert Type</label>
                        <select class="form-control mm-input" formControlName="type">
                          <option value="generalMessage">General update</option>
                          <option value="emergencyUpdate">Emergency update</option>
                          <option value="importantUpdate">Important update</option>
                        </select>
                      </div>

                      <div class="form-group">
                        <label>Title</label>
                        <input
                          class="form-control mm-input"
                          type="text"
                          placeholder="e.g. Service Schedule Update"
                          formControlName="name"
                        />
                        <small class="text-danger" *ngIf="alertForm.get('name')?.touched && alertForm.get('name')?.invalid">
                          Title is required.
                        </small>
                      </div>

                      <div class="form-group">
                        <label>Message</label>
                        <textarea
                          class="form-control mm-input"
                          rows="4"
                          placeholder="Write your alert message..."
                          formControlName="description"
                        ></textarea>
                        <small class="text-danger" *ngIf="alertForm.get('description')?.touched && alertForm.get('description')?.invalid">
                          Message is required.
                        </small>
                      </div>

                      <div class="mm-form__actions">
                        <button type="button" class="mm-btn mm-btn--ghost" (click)="closeCreateAlert()">Cancel</button>
                        <button type="submit" class="mm-btn mm-btn--success" [disabled]="isSubmittingAlert">
                          {{ isSubmittingAlert ? 'Sending...' : 'Send Alert' }}
                        </button>
                      </div>
                    </form>
                  </div>

                  <div class="mm-card mm-card--list" [class.mm-card--full]="!showCreateAlert">
                    <div class="mm-card__head">
                      <div class="mm-card__head-title">Recent Alerts</div>
                      <div class="mm-card__head-meta" *ngIf="recentAnnouncements?.length">
                        {{ recentAnnouncements.length }} total
                      </div>
                    </div>

                    <div class="mm-list" *ngIf="recentAnnouncements?.length > 0; else noAlerts">
                      <div
                        *ngFor="let announcemnt of recentAnnouncements | slice:0:10"
                        class="mm-alert-item"
                      >
                        <div class="mm-alert-item__top">
                          <span [class]="alertTypeBadgeClass(announcemnt.type)">
                            {{ alertTypeLabel(announcemnt.type) }}
                          </span>
                          <span class="mm-alert-item__date">
                            {{ announcemnt.createdAt | date: 'MMM dd, yyyy • hh:mm a' }}
                          </span>
                        </div>
                        <div class="mm-alert-item__title">{{ announcemnt.name || 'Alert' }}</div>
                        <div class="mm-alert-item__desc">{{ announcemnt.description }}</div>
                      </div>
                    </div>

                    <ng-template #noAlerts>
                      <div class="mm-empty">
                        <div class="mm-empty__title">No alerts yet</div>
                        <div class="mm-empty__subtitle">Click “Add Alert” to create your first alert.</div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
